import * as z from "zod"
import { IATAFlightSegmentStatus, FlightSegmentBookingStatus, DayOfWeek, ExpiryReason, AircraftType } from "@prisma/client"

export const FlightSegmentModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string().nullish(),
  aircraft_id: z.string().nullish(),
  origin_airport_id: z.string().nullish(),
  destination_airport_id: z.string().nullish(),
  iata_booking_status: z.nativeEnum(IATAFlightSegmentStatus).nullish(),
  booking_status: z.nativeEnum(FlightSegmentBookingStatus).nullish(),
  departs_at: z.date().nullish(),
  arrives_at: z.date().nullish(),
  is_schedule: z.boolean(),
  schedule: z.nativeEnum(DayOfWeek).array(),
  schedule_departs_at: z.date().nullish(),
  schedule_arrives_at: z.date().nullish(),
  starts_at: z.date().nullish(),
  expires_at: z.date().nullish(),
  expiry_reason: z.nativeEnum(ExpiryReason).nullish(),
  expiry_comment: z.string().nullish(),
  replaced_by_id: z.number().int().nullish(),
  replacement_initiated_at: z.date().nullish(),
  issued_by_schedule_id: z.number().int().nullish(),
  flight_number: z.string().nullish(),
  aircraft_type: z.nativeEnum(AircraftType).nullish(),
  quote_id: z.number().int().nullish(),
  quote_variant_id: z.number().int().nullish(),
  flight_path_position: z.number().int().nullish(),
  is_final_destination: z.boolean().nullish(),
  max_kg_per_piece: z.number().nullish(),
  max_cm_length: z.number().nullish(),
  max_cm_width: z.number().nullish(),
  max_cm_height: z.number().nullish(),
  smallest_max_cm: z.number().nullish(),
  biggest_max_cm: z.number().nullish(),
  rate_id: z.number().int().nullish(),
})
